// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs, { ValidatorStatic } from 'validatorjs';
import Form from 'mobx-react-form';


// define rule set interface.
export interface Validations {
  [key: string]: {
    function: (value: any, attribute?: string) => boolean;
    message: string;
  };
}

// Define a base rule set for common data types.
const baseValidations: Validations = {
  passwordStrength: {
    function(value) {
      const regExpr = /^(?=.*(\W))(?=.*([a-z]))(?=.*([A-Z])).{6,}$/g;

      return regExpr.test(value);
    },
    message: 'Invalid password format.'
  },
  samePass: {
    function(value, attribute) {
      const newValue = (this as Form).validator.input[attribute];

      return newValue === value;
    },
    message: 'Passwords do not match.',
  },
  array: {
    function(value) {
      return Boolean(value.length);
    },
    message: 'This field is required.'
  },
  number: {
    function(value) {
      return !isNaN(Number(value));
    },
    message: 'Invalid number format.'
  },
  positive: {
    function(value) {
      return Number(value) > 0;
    },
    message: 'This field should be positive.'
  },
  integer: {
    function(value) {
      return Number.isInteger(Number(value));
    },
    message: 'This field should be integer.'
  },

};

// Build plugin config from combining a base and an optional user-defined rule set.
export default function getPluginsConfig(customValidations?: Validations) {
  const rules = {
    ...baseValidations,
    ...customValidations,
  };

  return {
    dvr: dvr({
      package: validatorjs,
      extend: ({validator, form}) => {
        Object.keys(rules).forEach((key) =>
          validator.register(key, rules[key].function, rules[key].message)); // Register a custom set of <rule name, callback, error message>
      }
    })
  };
}
